// Shared constants for operation UI/logic

// Threshold of locally queued records that triggers the stronger warning UI.
export const CACHE_WARNING_RECORDS = 200;
